import { useEffect, useState } from "react";
import { ReactComponent as Bulb } from "@assets/images/bulb.svg";
import { ReactComponent as Estimated } from "@assets/images/Estimated.svg";
import { useTranslation } from "react-i18next";
import TipCardView from "@components/ui/TipCardView";
import { FormControl, MenuItem, Select } from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";

const FoodPreparingAdvice = ({ adviceList, day }) => {
  const [selectedDay, setSelectedDay] = useState(day);
  const { t } = useTranslation();
  const sortedAdviceArray = Object.entries(adviceList || {}).sort(
    ([, a], [, b]) => {
      return new Date(a.date) - new Date(b.date);
    }
  );

  const sortedAdviceObject = Object.fromEntries(sortedAdviceArray);
  useEffect(() => {
    setSelectedDay(day);
  }, [day]);
  return (
    <div className="bg-white shadow-lg p-6 rounded-lg w-full max-w-full bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)]">
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-[600] text-[#fff] text-[18px] md:text-[20x] font-[Lato]">
          {t(`dietPlanDashboard.foodPreparingAdvice.heading`)}
        </h2>
        <FormControl sx={{ minWidth: 120 }}>
          <Select
            value={selectedDay}
            onChange={(e) => setSelectedDay(e.target.value)}
            IconComponent={KeyboardArrowDown}
            sx={{
              borderRadius: "50px",
              backgroundColor: "white",
              "& .MuiSelect-select": {
                padding: "8px 16px",
                paddingRight: "32px !important",
                color: "#0575E6",
                fontSize: "16px",
                fontWeight: 500,
                textAlign: "center",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #0575E6",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #0575E6",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #0575E6",
              },
              "& .MuiSvgIcon-root": {
                color: "#0575E6",
                right: "8px",
              },
            }}
          >
            {Object.keys(sortedAdviceObject).map((day) => (
              <MenuItem
                key={day}
                value={day}
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#0575E6",
                  "&:hover": {
                    backgroundColor: "rgba(5, 117, 230, 0.1)",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(5, 117, 230, 0.2)",
                  },
                }}
              >
                {t(`days.${day.toLocaleLowerCase()}`)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <>
        <div className="border rounded-[17px] p-2 md:p-4 bg-white font-[Lato]">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
            <div className="text-[#fff] cursor-default text-[12px] md:text-[16px] font-[600] bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-full px-2 py-1 flex items-center gap-2 w-[fit-content]">
              <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                <Bulb />
              </p>{" "}
              {t(`dietPlanDashboard.foodPreparingAdvice.tipHeading`)}
            </div>
            <p
              className="text-[#0575E6]  text-[11px] md:text-[14px] border border-dashed
 border-[#868686] p-2"
            >
              <span className="text-[#535862] font-[400] text-[12px] md:text-[16px] flex items-center gap-2">
                <Estimated />{" "}
                {t(`dietPlanDashboard.foodPreparingAdvice.estimatedTime`)}:{" "}
                <span className="text-[#7B7B7B] text-[12px] md:text-[16px]">
                  {sortedAdviceObject[selectedDay]?.time}
                </span>
              </span>
            </p>
          </div>

          <p className="text-[14px] md:text-[18px] font-[500] font-[Lato] text-[#898787] mt-2">
            {sortedAdviceObject?.[selectedDay]?.tip}
          </p>
          {/* <p className="text-[#000] font-[500] text-[18px] mt-5">
            "{sortedAdviceObject[selectedDay]?.tip}"
          </p>

          <p className="text-[#7B7B7B] text-[18px]">
            {sortedAdviceObject[selectedDay]?.details}
          </p> */}
        </div>
        <TipCardView
          mindfulnessStepsData={sortedAdviceObject[selectedDay]?.details}
        />
      </>

      {/* <div className="mt-4 flex items-center text-blue-600 cursor-pointer hidden">
        <span className="text-lg">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.35504 3.5786C2.77862 3.83479 2.40234 4.41121 2.40234 5.04367V8.80642C2.40234 13.2497 5.47659 17.4047 9.6076 18.4134C13.7386 17.4047 16.8129 13.2497 16.8129 8.80642V5.04367C16.8129 4.41121 16.4366 3.83479 15.8602 3.5786L10.2561 1.08878C9.83977 0.90465 9.36743 0.90465 8.95913 1.08878L3.35504 3.5786ZM9.6076 5.60408C10.0479 5.60408 10.4082 5.96434 10.4082 6.40467C10.4082 6.84499 10.0479 7.20525 9.6076 7.20525C9.16728 7.20525 8.80702 6.84499 8.80702 6.40467C8.80702 5.96434 9.16728 5.60408 9.6076 5.60408ZM9.6076 8.80642C10.0479 8.80642 10.4082 9.16668 10.4082 9.60701V12.8093C10.4082 13.2497 10.0479 13.6099 9.6076 13.6099C9.16728 13.6099 8.80702 13.2497 8.80702 12.8093V9.60701C8.80702 9.16668 9.16728 8.80642 9.6076 8.80642Z"
              fill="#0575E6"
            />
          </svg>
        </span>
        <a href="#" className="ml-2 text-[#0575E6] text-[9px] md:text-[12px] ">
          View more tips
        </a>
      </div> */}
    </div>
  );
};

export default FoodPreparingAdvice;
